import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partnership_program: {
        subaffiliate_conditions: {
          header: 'HEADER',
          create_plan: 'CREATE_PLAN',
          modal_window: {
            remove: 'DELETE_MODAL_REMOVE',
            remove_question: 'DELETE_MODAL_REMOVE_QUESTION',
            delete: 'DELETE_MODAL_DELETE',
            cancel: 'DELETE_MODAL_CANCEL',
          },
          create_edit: {
            header_create: 'HEADER_CREATE',
            header_edit: 'HEADER_EDIT',
            save: 'BTN_SAVE',
            back: 'BTN_BACK',
            step_settings_header: 'STEP_SETTINGS_HEADER',
            form: {
              title: 'FORM_TITLE',
              description: 'FORM_DESCRIPTION',
            },
            step: {
              payment_size_empty: 'STEP_PAYMENT_SIZE_EMPTY',
              step: 'STEP',
              validations: {
                step_invalid: 'STEP_INVALID',
                payment_size_value_is_not_valid: 'PAYMENT_SIZE_INVALID',
              },
              modal_window: {
                set_condition: {
                  title: 'CONDITION_MODAL_TITLE',
                  cancel: 'CONDITION_MODAL_CANCEL',
                  save: 'CONDITION_MODAL_SAVE',
                  form: {
                    value: 'CONDITION_FORM_VALUE',
                    payment_column: 'CONDITION_FORM_PAYMENT_COL',
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
